import { toLower, startCase } from "lodash";

export const toStartCase = (value: string | null | undefined): string => {
  if (!value) return "";
  return startCase(toLower(value));
};
